/** Shared class strings for the two menu surfaces (dropdown and context). */

export const MENU_CONTENT =
  'ui-anim-pop z-50 min-w-[9rem] overflow-y-auto overflow-x-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg';

export const MENU_ITEM =
  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm transition-colors duration-150 ease-out data-[highlighted]:bg-muted data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0';

export const MENU_ITEM_DESTRUCTIVE =
  'text-destructive data-[highlighted]:bg-destructive/10 data-[highlighted]:text-destructive';

export const MENU_LABEL = 'px-2 py-1.5 text-xs font-medium text-muted-foreground';

export const MENU_SEPARATOR = '-mx-1 my-1 h-px bg-border';

/** Room on the left for the check / radio indicator. */
export const MENU_ITEM_INDENTED = 'pl-7';

export const MENU_INDICATOR =
  'absolute left-2 flex size-3.5 items-center justify-center text-foreground';
